'use client'

/**
 * TutorialView — client half of /tutorials/[slug].
 *
 * A thin wrapper: the three-column reader now lives in the shared
 * `ArticleView` (src/components/content/article-view.tsx), which the
 * converted Creating-a-Scene pages use too (CAS migration plan §2.3). The
 * server half is `src/lib/content/article-page.ts`.
 */
import { ArticleView } from '@/components/content/article-view'

export type {
  ArticleData,
  TutorialData,
  Section,
  SectionIntro,
  LinkedCard,
} from '@/components/content/article-view'

export function TutorialView(props: React.ComponentProps<typeof ArticleView>) {
  return <ArticleView {...props} />
}
